// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatStatus } from 'components/DataTable'
import { FormatModel } from './Formatters'

const columns = [{
  columnHeader: 'Code',
  columnKey: 'antennaCode',
  sortable: true,
}, {
  columnHeader: 'Manufacturer',
  columnKey: 'company',
  sortable: true,
}, {
  cellFormatter: FormatModel,
  columnHeader: 'Model',
  columnKey: 'modelNumber',
  sortable: true,
}, {
  columnHeader: 'Frequency (MHz)',
  columnKey: 'frequencyRange',
  sortable: true,
}, {
  columnHeader: 'Gain (dBi)',
  columnKey: 'gain',
  sortable: true,
}, {
  columnHeader: 'BW (°)',
  columnKey: 'beamwidth',
  sortable: true,
}, {
  columnHeader: 'Diameter (m/ft)',
  columnKey: 'diameterMandFt',
  sortable: true,
}, {
  columnHeader: 'RPE',
  columnKey: 'rpeNumber',
  sortable: true,
}, {
  columnHeader: 'Pattern Date',
  columnKey: 'patternDate',
  sortable: true,
}, {
  cellFormatter: FormatStatus,
  columnHeader: 'Status',
  columnKey: 'status',
  columnWidth: '60px',
  sortable: true,
}]

export default columns
